export default __webpack_public_path__ + "static/media/goc.e5ee61ad.png";